import React from 'react';

function Footer() {
  return (
    <footer>
      <span className="footer-name">© 2026 Souled Out</span>
      <ul className="footer-links">
        <li><a href="https://www.instagram.com/souldok_/" target="_blank" rel="noopener noreferrer" className="magnetic">Instagram</a></li>
        <li><a href="https://open.spotify.com/artist/25xfbDuDop0OFk1fOkEEbV" target="_blank" rel="noopener noreferrer" className="magnetic">Spotify</a></li>
        <li><a href="https://www.youtube.com/channel/UCJjXFyUE5WnfLirznYk9JMw" target="_blank" rel="noopener noreferrer" className="magnetic">YouTube</a></li>
      </ul>
    </footer>
  );
}

export default Footer;
